
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabserviceinkaregaonmidc() {



    const cardData =
    {
        keyword: 'Corporate Cab Services in Karegaon MIDC',
        heading: 'etravo : Corporate Cab Services in Karegaon MIDC',



"headingDescription": "eTravo provides reliable Corporate Cab Services in Karegaon MIDC, designed for manufacturing units, industrial companies, and corporate teams requiring safe, punctual, and efficient employee transportation. With well-maintained GPS-enabled vehicles and professional chauffeurs, eTravo ensures smooth daily commuting, shift-based transport, and executive travel across industrial zones. Flexible monthly and long-term plans make it an ideal mobility partner for companies operating in and around Karegaon MIDC.",

"top": "Top Industrial & Corporate Areas near Karegaon MIDC with eTravo",

"topPlaces": [
  {
    "title": "Karegaon MIDC Industrial Area",
    "description": "A developing industrial zone with manufacturing units and factories requiring daily employee transport and shift-based corporate cab services."
  },
  {
    "title": "Ranjangaon MIDC",
    "description": "A major industrial hub near Pune with multinational manufacturing companies, demanding large-scale employee transportation solutions."
  },
  {
    "title": "Shirur MIDC",
    "description": "An important industrial belt with textile and manufacturing units requiring reliable daily pickup and drop services."
  },
  {
    "title": "Sanwadi MIDC (Sanaswadi)",
    "description": "A growing industrial cluster near Pune-Nagar highway, supporting logistics and manufacturing businesses with workforce mobility needs."
  },
  {
    "title": "Wagholi Industrial & Logistics Zone",
    "description": "A rapidly developing area with warehouses, logistics hubs, and corporate offices requiring consistent transport services."
  },
  {
    "title": "Lonikand Industrial Area",
    "description": "An emerging industrial region with factories and supply chain units dependent on employee transportation services."
  },
  {
    "title": "Shikrapur MIDC Belt",
    "description": "A key industrial stretch hosting multiple production units and requiring structured shift-based cab operations."
  },
  {
    "title": "Chakan MIDC",
    "description": "One of Pune’s largest automotive and manufacturing hubs, requiring high-volume corporate transport solutions."
  },
  {
    "title": "Talegaon MIDC",
    "description": "A major industrial area with automobile and engineering companies needing reliable employee commute services."
  },
  {
    "title": "Koregaon Bhima Industrial Zone",
    "description": "A developing industrial corridor with factories and warehouses requiring consistent workforce transportation support."
  }
],


"services": [
{
"name": "Corporate Cab Karegaon MIDC",
"description": "eTravo offers reliable corporate cab services in Karegaon MIDC tailored for industrial and business travel needs. Our service ensures punctual pickups, comfortable rides, and professional chauffeurs, helping companies maintain smooth daily operations."
},
{
"name": "Taxi Service Karegaon MIDC",
"description": "Our taxi service in Karegaon MIDC provides quick and dependable transportation for employees and business professionals. eTravo ensures clean vehicles, timely service, and safe travel across industrial and nearby areas."
},
{
"name": "Company Cab Karegaon MIDC",
"description": "eTravo provides company cab services in Karegaon MIDC designed for employee transport and corporate travel. Our solutions ensure reliability, flexibility, and smooth commuting for organizations."
},
{
"name": "Industrial Area Cab Karegaon",
"description": "eTravo offers specialized cab services for industrial areas in Karegaon, ensuring efficient transportation for workers and executives. Our service supports factory operations with timely and dependable travel solutions."
},
{
"name": "Employee Transport Karegaon MIDC",
"description": "Our employee transport services in Karegaon MIDC are designed for safe and punctual workforce commuting. eTravo provides structured pickup and drop solutions, ensuring smooth daily travel for employees."
},
{
"name": "Office Cab Karegaon MIDC",
"description": "Simplify office commuting with eTravo’s office cab services in Karegaon MIDC. We provide reliable and comfortable transport for employees traveling between home and workplace."
},
{
"name": "Business Cab Service Karegaon",
"description": "eTravo’s business cab service in Karegaon ensures efficient transportation for meetings, site visits, and daily corporate activities. Our service focuses on punctuality and professional travel experiences."
},
{
"name": "Staff Cab Karegaon MIDC",
"description": "eTravo offers dependable staff cab services in Karegaon MIDC for daily employee commuting. Our service ensures timely pickups, safe rides, and smooth coordination for workforce mobility."
},
{
"name": "Corporate Travel Karegaon MIDC",
"description": "Our corporate travel services in Karegaon MIDC are designed for smooth business transportation. eTravo ensures reliable travel for executives and employees, supporting efficient operations."
},
{
"name": "Factory Transport Cab Karegaon",
"description": "eTravo provides factory transport cab services in Karegaon for industrial workers and staff. Our service ensures safe, timely, and well-coordinated travel to support factory operations."
},
{
"name": "Company Taxi Karegaon MIDC",
"description": "eTravo’s company taxi services in Karegaon MIDC provide flexible and convenient transportation for businesses. Our taxis are ideal for employee travel, client visits, and daily operations."
},
{
"name": "Industrial Cab Hire Karegaon",
"description": "Choose eTravo’s industrial cab hire in Karegaon for reliable and efficient transport solutions. Our service supports industrial zones with comfortable vehicles and professional drivers."
},
{
"name": "Corporate Fleet Karegaon MIDC",
"description": "eTravo offers corporate fleet services in Karegaon MIDC for companies requiring multiple vehicles. Our fleet solutions ensure consistent availability, proper maintenance, and smooth operations."
},
{
"name": "Employee Commute Karegaon MIDC",
"description": "Our employee commute services in Karegaon MIDC focus on safe and efficient daily travel. eTravo ensures punctual pickups and comfortable rides for a hassle-free commuting experience."
},
{
"name": "Office Transport Karegaon MIDC",
"description": "eTravo provides office transport services in Karegaon MIDC for smooth and reliable employee movement. Our service ensures efficient travel management and comfortable commuting for organizations."
}
],
"tableData": [
["Corporate Cab Karegaon MIDC", "Taxi Service Karegaon MIDC"],
["Company Cab Karegaon MIDC", "Industrial Area Cab Karegaon"],
["Employee Transport Karegaon MIDC", "Office Cab Karegaon MIDC"],
["Business Cab Service Karegaon", "Staff Cab Karegaon MIDC"],
["Corporate Travel Karegaon MIDC", "Factory Transport Cab Karegaon"],
["Company Taxi Karegaon MIDC", "Industrial Cab Hire Karegaon"],
["Corporate Fleet Karegaon MIDC", "Employee Commute Karegaon MIDC"],
["Office Transport Karegaon MIDC", ""]
],





"whychoose": [
    {
      "WhyChooseheading": "Specialized Corporate Cab Services in Karegaon MIDC",
      "WhyChoosedescription": "eTravo provides dedicated corporate cab services in Karegaon MIDC, ensuring smooth and reliable employee transportation for industries located in the Ranjangaon industrial belt near Pune." 
    },
    {
      "WhyChooseheading": "Strategic Location Coverage for Industrial Workforce",
      "WhyChoosedescription": "Karegaon MIDC is part of the well-known Ranjangaon industrial zone on Pune–Nagar Road, offering strong connectivity to Pune city and nearby industrial hubs. :contentReference[oaicite:0]{index=0}"
    },
    {
      "WhyChooseheading": "Efficient Daily Pickup and Drop for Employees",
      "WhyChoosedescription": "Our services are designed for factory staff and corporate employees, ensuring timely shift-based pickup and drop services without delays."
    },
    {
      "WhyChooseheading": "Fleet Suitable for Industrial and Corporate Needs",
      "WhyChoosedescription": "We offer a wide range of vehicles including sedans, SUVs, and employee transport vehicles suitable for industrial workforce and management-level travel."
    },
    {
      "WhyChooseheading": "Experienced Drivers for Industrial Routes",
      "WhyChoosedescription": "Our chauffeurs are well-versed with MIDC routes, factory timings, and traffic conditions, ensuring safe and efficient travel for employees."
    },
    {
      "WhyChooseheading": "Flexible Monthly and Contract-Based Plans",
      "WhyChoosedescription": "eTravo offers customizable plans for industries including daily commute services, shift-based transport, and long-term contracts tailored to company needs."
    },
    {
      "WhyChooseheading": "Safe and Well-Maintained Vehicles",
      "WhyChoosedescription": "All vehicles are regularly serviced and sanitized, ensuring safety, hygiene, and comfort for employees traveling to and from Karegaon MIDC."
    },
    {
      "WhyChooseheading": "24/7 Support for Industrial Transport Needs",
      "WhyChoosedescription": "Our support team operates round the clock to manage bookings, shift changes, and emergency travel requirements for uninterrupted industrial operations."
    }
  ]

}

const faqData = [
    [
        {
            question: 'What is corporate cab service in Karegaon MIDC?',
            answer: 'Corporate cab service in Karegaon MIDC provides organized transportation for employees and staff working in industrial units located in the Ranjangaon MIDC area.',
        },
        {
            question: 'Where is Karegaon MIDC located?',
            answer: 'Karegaon MIDC is located near Ranjangaon in Pune district, around 60–65 km from Pune city along the Pune–Ahmednagar highway. :contentReference[oaicite:1]{index=1}',
        },
        {
            question: 'Do you provide daily employee transport for factories in Karegaon MIDC?',
            answer: 'Yes, eTravo offers daily pickup and drop services for factory workers and corporate employees with fixed schedules and routes.',
        },
        {
            question: 'Can shift-based transportation be arranged?',
            answer: 'Yes, we provide transportation for day, night, and rotational shifts suitable for industrial operations.',
        },
        {
            question: 'What types of vehicles are available for MIDC transport?',
            answer: 'We offer hatchbacks, sedans, SUVs, and larger vehicles depending on employee strength and travel requirements.',
        },
        {
            question: 'Are drivers familiar with industrial routes?',
            answer: 'Yes, our drivers are experienced and well-aware of MIDC routes, ensuring efficient and timely travel.',
        },
        {
            question: 'Do you provide monthly transport contracts for industries?',
            answer: 'Yes, we offer cost-effective monthly and long-term corporate transport contracts for industrial clients.',
        },
        {
            question: 'Is the service available 24/7 for MIDC employees?',
            answer: 'Yes, our services operate round the clock to support all industrial shift timings.',
        },
        {
            question: 'Do you provide GST billing for corporate transport?',
            answer: 'Yes, we provide GST-compliant invoices for all corporate bookings and contracts.',
        },
        {
            question: 'How can I book corporate cab services in Karegaon MIDC?',
            answer: 'You can book through our website or contact our corporate support team for customized industrial transport solutions.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Santosh More',
        designation: 'Plant Manager, Manufacturing Unit, Ranjangaon MIDC',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo has significantly improved our employee transport in Karegaon MIDC. Their punctual service and route management are excellent for industrial operations.”',
    },
    {
        name: 'Ms. Priti Kulkarni',
        designation: 'HR Executive, Industrial Company, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“We rely on eTravo for our workforce transportation in Karegaon MIDC. Their flexible plans and reliable service ensure smooth daily commuting for our staff.”',
    },
];











    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Karegaon MIDC",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-karegaon-midc.jpg",
  "description": "Reliable corporate cab services in Karegaon MIDC by eTravo. Ideal for employee transport, factory staff commute, office pickup and drop, and industrial area travel with safe and timely service.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-services-in-karegaon-midc"
  }
};






    return (
        <div>

<Helmet>
  <title>Corporate Cab Services in Karegaon MIDC | Industrial & Staff Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate cab services in Karegaon MIDC with eTravo for employee transport, factory staff commute, office pickup and drop, and industrial travel needs. Safe and reliable rides." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/128.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabserviceinkaregaonmidc;